export default {
  i18n: {
    messages: {
      de: {
        detailsTitle: 'Opticheck Import',
        // buttons: {
        //   goToItem: 'Gehe zu Aufgabe',
        // },
        // fields: {
        //   id: 'Id',
        //   customer_id: 'Kundennummer',
        //   url: 'URL',
        //   created: 'Erstellt',
        //   updated: 'Aktualisiert',
        //   status: 'Status',
        //   check_last: 'Letzte Prüfung',
        //   check_interval_value: 'Prüfinterval',
        //   job_last: 'Letzter Job',
        //   check_optimization: 'Prüfe Optimierungen',
        //   check_screenshot: 'Prüfe Screenshot',
        //   check_countwords: 'Prüfe Anzahl Wörter',
        // },
      },
      en: {
        detailsTitle: 'Opticheck Import',
        // buttons: {
        //   goToItem: 'Go to task',
        // },
        // fields: {
        //   id: 'Id',
        //   customer_id: 'Customer Id',
        //   url: 'URL',
        //   created: 'Created',
        //   updated: 'Updated',
        //   status: 'Status',
        //   check_last: 'Last Check',
        //   check_interval_value: 'Check Interval',
        //   job_last: 'Last Job',
        //   check_optimization: 'Check Optimization',
        //   check_screenshot: 'Check Screenshot',
        //   check_countwords: 'Check Words (count)',
        // },
        // itemElements: {
        //   companyBusinessAreas: {
        //     title: 'Company business areas',
        //     headers: {
        //       businessArea: 'Business areas',
        //     },
        //   },
        // },
      },
    },
  },
}
